module.exports = __webpack_public_path__ + "img/19_35.501d7bf2.png";